export default defineNuxtRouteMiddleware((to, from) => {
  const referrer = useReferrer();
  referrer.value = from.fullPath;
});
